import { useSyncExternalStore } from 'use-sync-external-store/shim';

import { commandStore } from '../command-store';
import type { Command } from '../types';

const subscribe = (onStoreChange: () => void): (() => void) => {
    const subscription = commandStore.subscribe(onStoreChange);
    return () => {
        subscription.unsubscribe();
    };
};

const getSnapshot = (): Map<string, Command> => commandStore.state.commands;

/**
 * Subscribe to the current command list. Re-renders when commands change.
 */
export const useCommands = (): Command[] => {
    const commands = useSyncExternalStore(subscribe, getSnapshot);
    return [...commands.values()];
};
